import { z } from "zod";
import { apiOSS } from "./apiOSS";

const PATIENT_URL = `/medical/v1/patient`;

const medicalRecordStatusSchema = z.object({
  htmlCreatedAt: z.string().optional(),
  pdfCreatedAt: z.string().optional(),
});
type MedicalRecordStatus = z.infer<typeof medicalRecordStatusSchema>;

const medicalRecordUrlSchema = z.object({
  url: z.string(),
});

export async function getMedicalRecordStatus(patientId: string): Promise<MedicalRecordStatus> {
  const resp = await apiOSS.get(`${PATIENT_URL}/${patientId}/medical-record-status`);
  const mrStatus = medicalRecordStatusSchema.parse(resp.data);
  return mrStatus;
}

export async function getMedicalRecordUrl(
  patientId: string,
  conversionType: "html" | "pdf"
): Promise<string> {
  const resp = await apiOSS.get(`${PATIENT_URL}/${patientId}/medical-record`, {
    params: {
      conversionType,
    },
  });
  return medicalRecordUrlSchema.parse(resp.data).url;
}

const documentQueryProgressResultSchema = z.object({
  startedAt: z.string().optional(),
  requestId: z.string().optional(),
  convert: z
    .object({
      status: z.string(),
      total: z.number().optional(),
      successful: z.number().optional(),
      webhookSent: z.boolean().optional(),
    })
    .optional(),
  download: z
    .object({
      status: z.string(),
      total: z.number().optional(),
      successful: z.number().optional(),
      webhookSent: z.boolean().optional(),
    })
    .optional(),
});

export type DocumentQueryProgressResult = z.infer<typeof documentQueryProgressResultSchema>;

// TEMP: This is a temporary fix to get the query start date
export async function getDocumentQueryStatus(
  patientId: string
): Promise<DocumentQueryProgressResult> {
  const resp = await apiOSS.get(`/medical/v1/document/query`, {
    params: {
      patientId,
    },
  });
  return documentQueryProgressResultSchema.parse(resp.data);
}
